module.exports = __webpack_public_path__ + "assets/img/ComparisonBAPC.31a6945d.png";